import Main from './Main'
import CurrentLesson from './CurrentLesson'
import Plan from './Plan'
import Homework from './Homework'


export default { Main, CurrentLesson, Plan, Homework }